import script from "./_webhookChangeDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./_webhookChangeDetail.vue?vue&type=script&setup=true&lang=js"

import "./_webhookChangeDetail.vue?vue&type=style&index=0&id=3f481c72&lang=scss"

const __exports__ = script;

export default __exports__